import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import api from "@/services/api";

async function initApp() {
  const app = createApp(App);

  // ✅ Auth state (replaces license state)
  app.config.globalProperties.$isAuthed = false;

  // ✅ Check token before routing
  try {
    console.log("🔹 Checking auth token before app starts...");

    const token = localStorage.getItem("lotledgerToken");

    if (token) {
      console.log("✅ Token found. Validating against protected endpoint...");

      // Call any protected endpoint to validate token
      // (Authorization header is already injected by api.js interceptor)
      await api.get("/auction-houses/available");

      app.config.globalProperties.$isAuthed = true;
      console.log("✅ Token valid. User authenticated.");
    } else {
      console.log("🚨 No token found.");
    }
  } catch (error) {
    console.error("❌ Token validation failed:", error?.response?.data || error.message);
    localStorage.removeItem("lotledgerToken");
    app.config.globalProperties.$isAuthed = false;
  }

  app.use(router);

  // ✅ Guard routes (redirect to login page if not authed)
  router.beforeEach((to, from, next) => {
  const isLoginPage = to.path === "/licenses";
  const isAuthed = !!localStorage.getItem("lotledgerToken");

  if (!isAuthed && !isLoginPage) return next("/licenses");
  if (isAuthed && isLoginPage) return next("/dashboard");

  next();
});


  await router.isReady();
  app.mount("#app");
}

initApp();
